<template>
    <v-list nav dense pa-0 pr-2 ma-0>
        <v-list-item class="ma-0 pa-0" @click="MIX_go('/')">
            <v-btn text color="primary" width="100%" height="40" class="justify-start">
                <v-icon color="darkgrey">icons8-home</v-icon>
                <v-list-item-title class="darkgrey--text pl-2">Home</v-list-item-title>
            </v-btn>
        </v-list-item>
        <!-- <v-list-item class="ma-0 pa-0">
            <v-btn text disabled color="grey" width=100% height="40" class="justify-start">
                <v-icon color="darkgrey">icons8-male-user</v-icon>
	            <v-list-item-title class="grey--text pl-2">Profile</v-list-item-title>
            </v-btn>
        </v-list-item>
        <v-list-item class="ma-0 pa-0">
            <v-btn text disabled color="grey" width=100% height="40" class="justify-start">
                <v-icon color="darkgrey">icons8-online-support</v-icon>
	            <v-list-item-title class="grey--text pl-2">Support</v-list-item-title>
            </v-btn>
        </v-list-item> -->
        <v-list-item class="ma-0 pa-0" v-if="showInstallBanner" @click="install()">
            <v-btn text color="primary" width="100%" height="40" class="justify-start">
                <v-icon color="darkgrey">icons8-download</v-icon>
                <v-list-item-title class="darkgrey--text pl-2">Install App</v-list-item-title>
            </v-btn>
        </v-list-item>
        <v-list-item class="ma-0 pa-0" v-if="$store.getters.GET_currentUser != null" @click="logout()">
            <v-btn text color="primary" width="100%" height="40" class="justify-start">
                <v-icon color="darkgrey">icons8-exit</v-icon>
                <v-list-item-title class="darkgrey--text pl-2">Log Out</v-list-item-title>
            </v-btn>
        </v-list-item>
        <!-- <v-list-item class="ma-0 pa-0">
            <v-btn text disabled color="primary" width=100% height="40" class="justify-start">
                <v-icon color="grey">icons8-terms-and-conditions</v-icon>
                <v-list-item-title class="grey--text pl-2">T's And C's</v-list-item-title>
            </v-btn>
        </v-list-item> -->
        <v-list-item>
            <v-list-item-title class="grey--text pl-2">App Version {{ LATEST_VERSION }}</v-list-item-title>
        </v-list-item>
    </v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex' // Map the Getters from the Vuex Store
let installEvent
export default {
    name: 'MobileMenuList',
    data() {
        return {
            LATEST_VERSION: '1.3.3',
            showInstallBanner: false,
            installEvent: null,
            showPageElements: false // hide menu etc. when there's no user logged in
        }
    },
    created() {
        window.addEventListener('beforeinstallprompt', e => {
            e.preventDefault()
            installEvent = e
        })
    },
    methods: {
        ...mapActions(['ACT_currentUser']),
        logout() {
            // console.log('logout')
            this.$firebase.auth.signOut().then(() => {
                this.showPageElements = false
                this.$router.push('/login').catch(err => {
                    //   console.log("Route error: " + err);
                })
                this.ACT_currentUser(null)
                //                this.$store.commit("setUser", null);
            })
        },
        async install() {
            installEvent.prompt()
            // installEvent.userChoice.then(() => {
            //     installEvent = null;
            // });
        }
    }
}
</script>
